import { Unit } from "uom";
import * as UnitDivide from "../unit-divide";
import { Joule, Megajoule, Kilojoule, Therm, MegaBtu, Btu } from "./energy";
import { KiloWattHour } from "./energy2";
/// http://www.wolframalpha.com/input/?i=BTU and select 'Show exact conversions'
// Per Energy
export var OnePerKiloWattHour = UnitDivide.dimensionlessByEnergy("OnePerKiloWattHour", Unit.One, KiloWattHour);
export var OnePerBtu = UnitDivide.dimensionlessByEnergy("OnePerBtu", Unit.One, Btu);
export var OnePerMegaBtu = UnitDivide.dimensionlessByEnergy("OnePerMegaBtu", Unit.One, MegaBtu);
export var OnePerTherm = UnitDivide.dimensionlessByEnergy("OnePerTherm", Unit.One, Therm);
export var OnePerKilojoule = UnitDivide.dimensionlessByEnergy("OnePerKilojoule", Unit.One, Kilojoule);
export var OnePerMegajoule = UnitDivide.dimensionlessByEnergy("OnePerMegajoule", Unit.One, Megajoule);
export var OnePerJoule = UnitDivide.dimensionlessByEnergy("OnePerJoule", Unit.One, Joule);
//# sourceMappingURL=dimensionless-per-energy.js.map